import React from 'react';

const ChoiceButton = props => {
    const { 
        name, 
        handleClick 
    } = props;

    return (
        <button 
            className="button button--choice" 
            type="button" 
            onClick={handleClick}>
                {name}
        </button>
    );
};

const OptionButton = props => {
    const { 
        name, 
        handleClick 
    } = props;

    return (
        <button 
            className="button button--option" 
            type="button" 
            onClick={handleClick}>
                {name}
        </button>
    );
};

const ResetButton = (props) => {
    const { 
        handleClick,
        isInactive
    } = props;
    return (
        <button 
            disabled={isInactive}
            className="button btn btn-primary"
            onClick={handleClick}>von vorne</button>
    );
};

export {
    ChoiceButton, 
    OptionButton,
    ResetButton
};